import { useFormField } from '@calendly/form'

import { SearchableSelectField as RawSearchableSelectField } from './raw/searchable-select-field'

export const SearchableSelectField = (props) => {
  const [fieldProps, meta, { setValue, setTouched, setError }] = useFormField(props)

  const onChangeHandler = (value) => {
    setValue(value)
    setTouched(true)
    setError(undefined)
  }

  return (
    <RawSearchableSelectField
      {...fieldProps}
      onChange={onChangeHandler}
      error={meta.error}
    />
  )
}
